import { post } from '../index';

export const postFilterView = (payload) => {
  return post('/filter', payload);
};